import { Configuration, LogLevel, PublicClientApplication } from "@azure/msal-browser";
import { environment } from "../environments/environment";

const resolvedClientId = environment.aadClientId;
const resolvedTenantId = environment.aadTenantId || "common";
const resolvedAuthority = `https://login.microsoftonline.com/${resolvedTenantId}`;
const resolvedRedirectUri = environment.aadRedirectUri || window.location.origin;
const resolvedPostLogoutRedirectUri =
  environment.aadPostLogoutRedirectUri || window.location.origin;

const msalConfig: Configuration = {
  auth: {
    clientId: resolvedClientId,
    authority: resolvedAuthority,
    redirectUri: resolvedRedirectUri,
    postLogoutRedirectUri: resolvedPostLogoutRedirectUri,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: environment.aadScopes.split(","),
};

export const msalInstance = new PublicClientApplication(msalConfig);


